// extracted by mini-css-extract-plugin
export var defaultWrapper = "_jm-3";
export var downloadButton = "_jm-4";
export var fileContainer = "_jm-9 _jm-7";
export var fileContainerBase = "_jm-7";
export var fileContainerFixedHeight = "_jm-8 _jm-7";
export var fileInfo = "_jm-5";
export var fileInfoWidthRestricted = "_jm-6";
export var fileType = "_jm-1";
export var fileTypeName = "_jm-2";
export var image = "_jm-0";
export var link = "_jm-b";
export var overflowEllipsis = "_jm-a";